import React from "react";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useOutletContext, useLocation } from "react-router-dom";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import { useTranslation } from "react-i18next";
import PortfolioSection from "../components/Games/PortfolioSection";

const BuySellPage = () => {
  const { t } = useTranslation();
  const [sidebarToggle] = useOutletContext();
  const location = useLocation();
  const { game_id } = location.state || {};

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={t("Portfolio")} />
      <PortfolioSection gameId={game_id} slug={null} user_id={null} isSelfProfile={true} ignoreDesign={true} />
    </>
  );
};

export default BuySellPage;
